import React from "react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const { user, refresh } = useAuth();
  const [seeding, setSeeding] = React.useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const seed = async () => {
    setSeeding(true);
    try {
      const r = await api.post("/dev/seed");
      toast.success(r.data.seeded ? "Demo data seeded" : "Demo data already exists");
    } catch (e) {
      toast.error("Seed failed");
    } finally { setSeeding(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-slate-50">
      <div className="hidden md:flex sidebar flex-col justify-between p-10 relative overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-sky-500 flex items-center justify-center text-white font-bold text-lg">S</div>
            <div>
              <div className="text-white font-semibold">Sangam Plastic Industries</div>
              <div className="text-slate-400 text-xs uppercase tracking-wider">Manufacturing ERP / MES</div>
            </div>
          </div>
        </div>
        <div className="relative z-10 text-slate-300 max-w-md">
          <h1 className="text-3xl font-bold text-white leading-tight mb-3">One connected shop floor.</h1>
          <p className="text-sm text-slate-400">From HDPE resin GRN to finished bottle dispatch — production orders, moulds, QC batches, downtime, and OEE, all in real time.</p>
          <div className="grid grid-cols-3 gap-4 mt-8">
            <div><div className="text-sky-400 font-mono text-xl">48+</div><div className="text-[10px] uppercase text-slate-500">Modules</div></div>
            <div><div className="text-emerald-400 font-mono text-xl">2</div><div className="text-[10px] uppercase text-slate-500">Units</div></div>
            <div><div className="text-amber-400 font-mono text-xl">6</div><div className="text-[10px] uppercase text-slate-500">Machines</div></div>
          </div>
        </div>
        <div className="text-slate-500 text-xs relative z-10">© Sangam Plastic Industries • Chennai</div>
        <div className="absolute -right-24 -bottom-24 w-96 h-96 rounded-full bg-sky-500/10 blur-3xl"></div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <h2 className="text-2xl font-bold text-slate-900 mb-1">Welcome back</h2>
          <p className="text-sm text-slate-500 mb-6">Sign in with your Google account to enter the ERP.</p>
          <button
            data-testid="btn-google-login"
            onClick={handleGoogle}
            className="w-full flex items-center justify-center gap-3 border border-slate-300 bg-white hover:bg-slate-50 rounded-lg py-2.5 text-sm font-medium text-slate-800 transition"
          >
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
            Continue with Google
          </button>
          <div className="mt-6 border-t border-slate-200 pt-5">
            <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-2">Demo environment</div>
            <button data-testid="btn-seed-data" onClick={seed} disabled={seeding} className="w-full text-xs py-2 rounded-lg border border-dashed border-slate-300 hover:border-sky-500 hover:text-sky-600 text-slate-600">
              {seeding ? "Seeding..." : "Load Sangam demo data (units, machines, orders)"}
            </button>
            <p className="text-[11px] text-slate-400 mt-3">Owner <span className="font-mono">b.darshansurana@gmail.com</span> is auto-promoted to CEO/Admin on first sign-in.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
